export default {
  default: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/layouts/default.vue").then(m => m.default || m),
  home: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/layouts/home.vue").then(m => m.default || m),
  immersive: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/layouts/immersive.vue").then(m => m.default || m)
}